import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { FaUserFriends } from "react-icons/fa";
import HeaderMain from "../../components/common/HeaderMain/HeaderMain";
import SocialMediaHandle from "../../components/common/SocialMediaHandle/SocialMediaHandle";
import SharePageButton from "../../components/common/SharePageButton/SharePageButton";
import Tabs from "../../components/common/Tabs/Tabs";
import Memory from "../../components/common/Memory/Memory";
import Footer from "../../components/single/Footer/Footer";
import FallbackImage from "../../components/common/FallbackImage/FallbackImage";
import styles from "./CreatorPage.module.css";
import { useParams } from "react-router-dom";
import { apiFetch, API_BASE } from "../../utils/api";
import * as Sentry from "@sentry/react";

const tabOptions = ["On Sale", "Owned", "Collections", "Activity", "Following", "Created"];

const CreatorPage = () => {
  const { descriptor } = useParams();
  const [visibleMemories, setVisibleMemories] = useState(8);
  const [creator, setCreator] = useState(null);
  const [memoryData, setMemoryData] = useState([]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const user = await apiFetch(`/profile/${descriptor}`, {}, true);
        setCreator(user);
      } catch (err) {
        Sentry.captureException(err);
        console.error("❌ Failed to fetch creator profile:", err);
      }
    };

    const fetchMemories = async () => {
      try {
        const memories = await apiFetch(`/api/profile/memories/all`, {
          method: "POST",
          body: JSON.stringify({ descriptor, amount: 50 }),
        }, false, true);
        setMemoryData(Array.isArray(memories) ? memories : []);
      } catch (err) {
        Sentry.captureException(err);
        console.error("❌ Failed to fetch creator memories:", err);
      }
    };

    if (descriptor) {
      fetchProfile();
      fetchMemories();
    }
  }, [descriptor]);

  const handleLoadMore = () => {
    setVisibleMemories(prevCount => prevCount + 8);
  };

  const handleTabChange = (selectedTab) => {
    console.log("Selected Tab:", selectedTab);
  };

  if (!creator) return null;

  return (
    <Box className={styles.creatorPage}>
      <HeaderMain />

      <Box className={styles.header}>
        <FallbackImage className={styles.bgIcon} alt="" src={`${API_BASE}${creator.background_image}`} />

        <Box className={styles.actions}>
          {/* <Button className={styles.followButton}>
            <FaUserFriends className={styles.followIcon} />
            Follow
          </Button> */}
          <SharePageButton whiteBackground={true} title={creator.name} />
        </Box>

        <Box className={styles.profile}>
          <FallbackImage className={styles.imgIcon} alt="" src={`${API_BASE}${creator.icon_image}`} type={'user'} />
          <Box className={styles.profileInfo}>
            <h1 className={styles.creatorName}>{creator.name} {creator.surname}</h1>
            <Box className={styles.stats}>
              {/* <Box className={styles.statItem}>
                <span>Followers</span>
                <strong>96</strong>
              </Box>
              <Box className={styles.statItem}>
                <span>Following</span>
                <strong>28</strong>
              </Box> */}
              <Box className={styles.statItem}>
                <span>Items</span>
                <strong>{memoryData.length}</strong>
              </Box>
            </Box>
            <Box className={styles.socialMediaHandles}>
              {creator.twitter && <SocialMediaHandle platform="Twitter" handle={creator.twitter} />}
              {creator.instagram && <SocialMediaHandle platform="Instagram" handle={creator.instagram} />}
              {creator.telegram && <SocialMediaHandle platform="Telegram" handle={creator.telegram} />}
              {creator.tiktok && <SocialMediaHandle platform="TikTok" handle={creator.tiktok} />}
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className={styles.description}>
        {creator.description.split('\n').map((line, idx) => (
          <span key={idx}>
            {line}
            <br />
          </span>
        ))}
      </Box>

      <Box className={styles.filters}>
        {/* <Tabs tabs={tabOptions} onTabChange={handleTabChange} /> */}
      </Box>

      <Box className={styles.grid}>
        {memoryData.slice(0, visibleMemories).map((memory) => (
          <Memory key={memory.id} {...memory} />
        ))}
      </Box>

      {visibleMemories < memoryData.length && (
        <Button className={styles.loadMoreButton} onClick={handleLoadMore}>
          Load More
        </Button>
      )}

      <Footer />
    </Box>
  );
};

export default CreatorPage;